import React, { Component } from "react";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { CCard ,CCardImage,CCardBody,CCardTitle,CCardText,CButton} from '@coreui/react'
import forwardButton from "../../../images/right-arrow.svg"
import previousButton from "../../../images/previous.svg"


import dayjs from "dayjs";

class MessageA56 extends Component {

    constructor(props) {
        super(props);
        this.linkRenderRef = React.createRef();
    }

    render() {
         var carouselCard   = (this.props.entry && this.props.entry.text_data && this.props.entry.text_data.carouselCard) || {};
         
         // let object = JSON.parse(carouselCard);
         //let slides = .cardCcarouselCardontents.length 
        //  a.carouselCard.cardContents
       
        

        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <CarouselProvider naturalSlideWidth={100} naturalSlideHeight={100} totalSlides={carouselCard.cardContents.length}>
                <ButtonBack className="A56-button-1"><img src={previousButton} style={{width:"40px",height:"40px",background:"none !important",border:"none !important"}}/></ButtonBack>
                <div style={{display:"flex",width:"82%",background:"#525252",marginLeft:"auto",marginRight:"auto",borderRadius:"12px"}}>
                    <Slider>
                   {carouselCard.cardContents.map((item,i) =>
                       <div>
                        <Slide index={i}>
                        <CCard style={{ width: '100%',height:'100%' }}>
                        <CCardImage orientation="top" src="https://cctb.euwest01.umbraco.io/media/cudlgazs/4-2.jpeg?width=500&mode=max&animationprocessmode=first"  style={{maxWidth:"100%",maxHeight:"55%",minWidth:"100%",marginLeft:"auto",marginRight:"auto",display:"block"}}/>
                        <CCardBody>
                            <CCardTitle>{item.title}</CCardTitle>
                            <CCardText>
                            {item.description}
                            </CCardText>
                            <CButton className="A56-button" onClick = {() =>{window.open(item.suggestions[1].action.openUrlAction.url)}} >{item.suggestions[0].reply.text}</CButton>
                        </CCardBody>
                        </CCard>
                        </Slide>
                        </div>
                        )} 
                    </Slider>
                    </div>
                    <ButtonNext  className="A56-button-2"><img src={forwardButton}style={{width:"40px",height:"40px",background:"none",border:"none"}}/></ButtonNext>

                </CarouselProvider>
                
                    <br />
                
                {   this.props.isLastEntry && this.props.sentTimestamp&& <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
            </div>
        )
    }

    componentDidMount() {
        let text      = (this.props.entry && this.props.entry.text) || "";
        // this.linkRenderRef.current.innerHTML = text;
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
        
    }

    messageBoxClassName = () => {
        return "s360-message-box-received-A56";
    }

    messageContainerClassName = () => {
        return "s360-message-cotainer-received-56";
       
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
       
    }

    messageContainerStyle = () => {
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
        
    }

}

export default MessageA56;